import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggerService } from '../../../../shared/services/logger.service';
import { RoutingService } from '../../../../shared/services/routing.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'ppl-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  isVisible = false;
  dropdownOpen = false;

  isAlertVisible = false;
  isToasterVisible = false;
  isSideDrawerVisible = false;

  handleClose(): void {
    console.log("Alert was closed");
    this.isAlertVisible = false;
  }

  handleToasterClose(): void {
    console.log("Alert was closed");
    this.isToasterVisible = false;
  }

  handleSideDrawerClose(): void {
    console.log("Alert was closed");
    this.isSideDrawerVisible = false;
  }

  menuSelected: string | undefined;
  selProgramCode?: string;

  constructor(private router: RoutingService, private logger : LoggerService){
  }

  ngOnInit() {
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  // Close dropdown when clicking outside of it
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    
    // Check if the clicked element is within the profileClick container or the dropdown menu
    const clickedInside = target.closest('.profileClick') || target.closest('.dropdown-menu');

    if (!clickedInside && this.dropdownOpen) {
      this.dropdownOpen = false;
    }
  }  

  manageProfile() {
    console.log('Manage Profile clicked');
  }

 

  homeRedirection(){
    this.router.navigate(`/`);
  }
}
